import {Component, OnInit} from '@angular/core';
import {provideNativeDateAdapter} from '@angular/material/core';
import {Business} from '../../models/business.model';
import {TimeZoneCode} from '../../models/time-objects.model';
import {Country} from '../../models/country.model';
import {Currency} from '../../models/currency.model';
import {Locale} from '../../models/locale.model';
import {BusinessService} from '../../_service/business.service';

@Component({
  selector: 'app-account-settings',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.css.css.css',
})
export class AccountSettingsComponent implements OnInit {
  configList: any;
  business: Business;
  timezones: TimeZoneCode[];
  countries: Country[];
  currencies: Currency[];
  locales: Locale[];
  accessibleMode: boolean = false;
  staffLabelList: any;
  clientLabelList: any;
  allowedTimezones: TimeZoneCode[];


  constructor(private businessService: BusinessService) {
    this.configList = this.businessService.getConfigList();
    this.staffLabelList = this.businessService.getStaffLabels();
    this.clientLabelList = this.businessService.getClientLabels();
  }

  ngOnInit() {
    this.businessService.getBackOfficeSettingsBusinessByKey('accessibleMode').subscribe(value => {
      this.accessibleMode = (!!(value.value && value.value === 'true'));
    });
    this.businessService.getAllTimezones().subscribe(value => {
      this.timezones = value;
      this.businessService.getBackOfficeSettingsBusinessByKey('allowedTimezones').subscribe(value => {
          this.allowedTimezones = JSON.parse(value.value);
          if(this.allowedTimezones === null || this.allowedTimezones === undefined) {
            this.allowedTimezones = this.timezones;
          }
      });
    });
    this.businessService.getAllCountries().subscribe(value => {
      this.countries = value;
    });
    this.businessService.getAllCurrencies().subscribe(value => {
      this.currencies = value;
    });
    this.businessService.getLocales().subscribe(value => {
      this.locales = value;
    });
    this.business = this.businessService.getBusiness();

  }



}
